import { render } from "./PasarelasPagosNew.vue?vue&type=template&id=0251a8fb&scoped=true"
import script from "./PasarelasPagosNew.vue?vue&type=script&lang=js"
export * from "./PasarelasPagosNew.vue?vue&type=script&lang=js"

import "./PasarelasPagosNew.vue?vue&type=style&index=0&id=0251a8fb&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0251a8fb"]])

export default __exports__